import { render } from "./InvestorPresentations.vue?vue&type=template&id=ac5c2eee"
import script from "./InvestorPresentations.vue?vue&type=script&lang=js"
export * from "./InvestorPresentations.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__